import { render } from "./AppConfirmDialog.vue?vue&type=template&id=9b4570c6&scoped=true&ts=true"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=ts"

import "./AppConfirmDialog.vue?vue&type=style&index=0&id=9b4570c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b4570c6"]])

export default __exports__